import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_84092)">
                <path
                    d="M14.168 1.66797H5.83464C3.53345 1.66797 1.66797 3.53345 1.66797 5.83464V14.168C1.66797 16.4692 3.53345 18.3346 5.83464 18.3346H14.168C16.4692 18.3346 18.3346 16.4692 18.3346 14.168V5.83464C18.3346 3.53345 16.4692 1.66797 14.168 1.66797Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M13.3376 9.4772C13.4405 10.1707 13.322 10.8791 12.9991 11.5014C12.6762 12.1237 12.1653 12.6284 11.539 12.9436C10.9127 13.2588 10.203 13.3685 9.5108 13.2571C8.81858 13.1458 8.17911 12.8189 7.68335 12.3232C7.18758 11.8274 6.86076 11.1879 6.74937 10.4957C6.63798 9.8035 6.7477 9.09378 7.06292 8.46752C7.37814 7.84125 7.8828 7.33032 8.50513 7.00741C9.12747 6.68449 9.83577 6.56603 10.5293 6.66887C11.2367 6.77377 11.8917 7.10342 12.3974 7.60913C12.9031 8.11483 13.2327 8.76977 13.3376 9.4772Z"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.582 5.41797H14.5904"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_84092">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconProfilePencil;
